module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAQdJREFUaAXt2UEKwjAUhOHoZXOM6jFyWxlIN4Uife/NTBYJFDfG/l9SwWBre+wV8K3AGOODy1fQ2it68xl+zPnf3rsFEgJc4s81sCAeA27ibYj3eeei10P9nXi8A4D+2QW8RfY4hQArIcKAVRApwAqINMCNKAE4EWUAF6IU4ECUA9QICkCJoAFUCCpAgaAD2AgJgImQAVgIKYCBqD7QoFE6pDvAOAjJAIx4bLUEwIqXAJjxdAA7ngpQxNMAqngKQBlfDlDHlwIc8WUAV3wJwBmfBrjjU4AV4sOAVeJDgJXiAag+0Mj+2EA8Rujn9M0uyOPDAEy8ICzx6EgNICYk9Tl78l4B4wr8ABcYx1j/VenoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/assets/icons/icon-arrow@3x.png
// module id = 127
// module chunks = 46